
    import './styles.scoped.css';
    export default {
  "slider": "awsui_slider_cqzlk_vl70c_141",
  "slider-side": "awsui_slider-side_cqzlk_vl70c_176",
  "slider-icon": "awsui_slider-icon_cqzlk_vl70c_183",
  "slider-icon-bottom": "awsui_slider-icon-bottom_cqzlk_vl70c_189",
  "slider-icon-side": "awsui_slider-icon-side_cqzlk_vl70c_193"
};
  